import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@mantine/core';
import { triggerNotification } from '../../../helpers/notificationHelper';
import { Context as StoreUserContext } from '../../../providers/StoreUserContextProvider';
import EcomProductCollectionShowcase from './EcomProductCollectionShowcase';
import { ANALYTIC_MERCH_PACKAGE_SHOWCASE_LOCATION_ENUM } from '../../../config/constants';
import AppStack from '../../common/AppStack';
// import WsProductInformationDisplay from './webstore/sections/productInformation/WsProductInformationDisplay';
import { config as defaultProductDisplayConfig } from './webstore/pages/wsDefaultProductDisplayConfig';
import WsProductInformationDisplay from './webstore/sections/productInformation/WsProductInformationDisplay';

const WebstoreProductDetailsPage = ({
  regAssociation,
  ecomStore,
  urlHandle,
  uuid,
  defaultVendorVariantUuid,
  themeConfig,
  mediaQueries,
  colorSchemes,
  onAddProductSuccess,
  analyticCta,
  isCheckoutView
}) => {
  const { state, fetchEcomStoreProductBulk } = useContext(StoreUserContext);

  const ecomStoreProduct =
    (urlHandle || uuid) && ecomStore?.pkEcomStore
      ? state.ecomStoreProductHistory.value.find(
          (f) =>
            (f.urlHandle === urlHandle || f.uuid === uuid) &&
            f.fkEcomStore === ecomStore?.pkEcomStore
        )
      : null;

  const productNotFound =
    (regAssociation && !ecomStore) ||
    (ecomStoreProduct?.urlHandle
      ? state.ecomStoreProductHistory.urlsNotFound.includes(urlHandle)
      : state.ecomStoreProductHistory.uuidsNotFound.includes(uuid));

  useEffect(() => {
    if (!ecomStoreProduct && ecomStore) {
      fetchEcomStoreProductBulk(
        ecomStore.pkEcomStore,
        {
          urlHandles: urlHandle ? [urlHandle] : null,
          uuids: uuid ? [uuid] : null
        },
        null,
        (e) => {
          triggerNotification(
            'There was a problem loading the product. Please try again later.'
          );
        }
      );
    }
  }, [urlHandle, uuid, ecomStore?.pkEcomStore]);

  return (
    <AppStack style={{ gap: 20 }}>
      <WsProductInformationDisplay
        baseStoreUrl={`/association/${regAssociation?.pkRegAssociation}`}
        blocks={defaultProductDisplayConfig.blocks}
        colorSchemes={colorSchemes}
        config={defaultProductDisplayConfig}
        ctaCaptured={analyticCta}
        ecomStoreCartProduct={null}
        ecomStoreProduct={ecomStoreProduct}
        ecomStoreTheme={{ ecomStore }}
        isCheckoutView={isCheckoutView}
        mediaQueries={mediaQueries}
        onAddOrUpdateCallback={() => {
          triggerNotification('Product added to cart', 'Success', 'green');
        }}
        onAddProductSuccess={onAddProductSuccess}
        onEditCancel={() => {}}
        productNotFound={productNotFound}
        themeConfig={themeConfig}
      />

      <Divider />

      <EcomProductCollectionShowcase
        analyticCta={
          ANALYTIC_MERCH_PACKAGE_SHOWCASE_LOCATION_ENUM.PRODUCT_DETAILS_PAGE_FOOTER
        }
        excludedProductUrlHandles={[urlHandle]}
        loading={!regAssociation}
        pkEcomStore={ecomStore?.pkEcomStore}
        pkRegAssociation={regAssociation?.pkRegAssociation}
        showCollectionTitle
        titleOverride="You may also like"
      />
    </AppStack>
  );
};

WebstoreProductDetailsPage.propTypes = {
  analyticCta: PropTypes.string,
  colorSchemes: PropTypes.array,
  defaultVendorVariantUuid: PropTypes.string,
  ecomStore: PropTypes.object,
  isCheckoutView: PropTypes.bool,
  mediaQueries: PropTypes.object,
  onAddProductSuccess: PropTypes.func,
  regAssociation: PropTypes.object,
  themeConfig: PropTypes.object,
  urlHandle: PropTypes.string,
  uuid: PropTypes.string
};

export default WebstoreProductDetailsPage;
